const isString = (value) => typeof value === 'string' || value instanceof String
const isArray = Array.isArray
const normalize = (str) => str.trim().replace(/\s+/g, ' ')

export function clsx(...args) {
    const classes = args.map((arg) => {
        if (isString(arg)) {
            return normalize(arg)
        }
        if (isArray(arg)) {
            return clsx(...arg)
        }
        return ''
    })
    return classes.filter(Boolean).join(' ')
}

export default clsx

